import {Component, Input} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AQH_EVE_15, AQH_EVE_20} from '../../../../../../../../../../@shared/models/input.module';
import {EventResponse, SponsorResponse} from '../../../../../../../../../../@shared/models/response.module';

@Component({
  selector: 'app-add-sponsor',
  standalone: false,
  templateUrl: './add-sponsor.html',
  styleUrl: './add-sponsor.css'
})
export class AddSponsor {
  @Input() event: EventResponse

  sponsor_name = '';
  sponsor_description = '';

  logoFile: File | null = null;
  imageFile: File | null = null;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal) {
  }

  onSave() {
    const payload: AQH_EVE_15 = {
      sponsor_name: this.sponsor_name.trim(),
      sponsor_description: this.sponsor_description.trim(),
    };

    this.eventsService.createSponsor(payload).subscribe((res: any) => {
      console.log('Sponsor created:', res);
      const sponsor: SponsorResponse = res.data;

      // Upload logo if provided
      if (this.logoFile && sponsor) {
        let logoPayload: AQH_EVE_20 = {
          sponsor_id: sponsor.sponsor_id,
          image_type: 'logo',
          image: this.logoFile
        }
        this.eventsService.uploadSponsorImage(logoPayload).subscribe(() => {
          console.log('Logo uploaded')
        });
      }

      // Upload banner image if provided
      if (this.imageFile && sponsor) {
        let imagePayload: AQH_EVE_20 = {
          sponsor_id: sponsor.sponsor_id,
          image_type: 'image',
          image: this.imageFile
        }
        this.eventsService.uploadSponsorImage(imagePayload).subscribe(() => {
          console.log('Image uploaded')
        });
      }

      // Return the sponsor data so parent components can decide where to add it
      this.modal.close(sponsor);
    })
  }

  close() {
    this.modal.close();
  }
}
